module.exports = __webpack_public_path__ + "img/food_truck.c87cea53.jpg";